import { Injectable } from '@angular/core';
import { LettingFeatureColumnComponent } from '../component/letting-feature-column/letting-feature-column.component';
import { ColumnVisibility } from '../../core/model/column-definition';
import { AllowSort } from '../../core/service/factory/allow-sort';
import { ColumnDefinitionFactory } from '../../core/service/factory/column-definition-factory.service';
import { LanguageService } from '../../core/service/language.service';
import { LettingFeature } from '../model/letting-feature';

@Injectable()
export class LettingFeatureColumnHelper {
  constructor(
    private readonly columnDefinitionFactory: ColumnDefinitionFactory,
    private readonly languageService: LanguageService
  ) {}

  createLettingFeatureColumnDefinitions(features: LettingFeature[], columnDefinitionArray: any[]): void {
    for (const feature of features) {
      columnDefinitionArray.push(
        this.columnDefinitionFactory.createComponentBased(
          this.getCaption(feature),
          `lettingFeatureReferenceTypes.${feature.id}`,
          LettingFeatureColumnComponent,
          { visibility: ColumnVisibility.optional, allowSort: AllowSort.No }
        )
      );
    }
  }

  private getCaption(feature: LettingFeature): string {
    const currentTranslation = feature.phrase?.find(translation => translation.cultureName === this.languageService.currentCultureLang);
    const caption = currentTranslation?.translationText || feature.phrase?.find(translation => !!translation.translationText)?.translationText || '';
    return `${caption} (${this.languageService.instant('LETTING_FEATURE.FILTER_SUFFIX')})`;
  }
}
